import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./HariPelaksanaan.scss";
import TopInfo from "../../Components/TopInfo/TopInfo";
import Heading from "../../Components/Heading/Heading";
import { Link } from "react-router-dom";

import penetasan from "../../Assets/Penetasan-Revisi/Hari-Penetasan_Kenzie-Andhika-Theodorus-Suhanto_1-Large.jpeg";
import pembentukan1 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan-Hari-1_Johan-Felix_28-Large.jpeg";
import pembentukan2 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan-Hari-2_Kenzie-Andhika-Theodorus-Suhanto_258-Large.jpeg";
import kulper from "../../Assets/Kuliah-Perdana-Revisi/Kuliah-Perdana_Johan_31-Large.jpeg";

const HariPelaksanaan = () => {
  const path = window.location.pathname;

  const hari = [
    {
      hari: "Hari",
      tema: "PENETASAN",
      link: "/hari-pelaksanaan/hari-penetasan",
      img: penetasan,
    },
    {
      hari: "Pembentukan",
      tema: "HARI SATU",
      link: "/hari-pelaksanaan/pembentukan-hari-1",
      img: pembentukan1,
    },
    {
      hari: "Pembentukan",
      tema: "HARI DUA",
      link: "/hari-pelaksanaan/pembentukan-hari-2",
      img: pembentukan2,
    },
    {
      hari: "Kuliah",
      tema: "PERDANA",
      link: "/hari-pelaksanaan/kuliah-perdana",
      img: kulper,
    },
  ];

  return (
    <>
      <div className="HariPelaksanaan">
        <div className="pohon"></div>
        <TopInfo />
        <Heading nama="Hari Pelaksanaan" job="" />
        {/* <div className="heading">
          <div className="judul">
            <p className="nama">Hari Pelaksanaan</p>
            <p className="job">Ini bakal jadi text bawahnya title yang intinya kea penjelasan lebih lanjut terkait titlenya gitu</p>
          </div>
        </div> */}
        <div className="timeline">
          {hari.map((item) => (
            <Link to={item.link}>
              <div
                className="timeline-card"
                style={{
                  backgroundImage: `linear-gradient(180deg, rgba(2,0,36,0) 65%, rgba(0,0,0,1) 100%), url(${item.img})`,
                }}
              >
                <div className="timeline-card-day">
                  <a>{item.hari}</a>
                </div>
                <div className="timeline-card-title">
                  <a>{item.tema}</a>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default HariPelaksanaan;
export { HariPelaksanaan };
